// extracted by mini-css-extract-plugin
export default {"link":"U2g8xO","root":"YqNuz5","label":"te3E0j"};